import { SMOKEBALL_EXPORT_TYPES, SourceSystemType } from "../types";

export const isJumpstartImport = (sourceSystem: SourceSystemType | undefined): boolean =>
  sourceSystem === "jumpstart";

export const isSmokeballExport = (sourceSystem: SourceSystemType | undefined): boolean => 
  sourceSystem ? SMOKEBALL_EXPORT_TYPES.includes(sourceSystem) : false;